import { Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { EditorModalType } from "./ComponentEditorContext";
import { useModalEditorDisplayContext } from "./ModalEditorContext";
import { usePathContext } from "./PathInfo";

interface OpenPositionsEditorButtonProps {
  propName: string;
  value: object;
}

export function OpenPositionsEditorButton(props: OpenPositionsEditorButtonProps) {
  const { showModal, setModalContext } = useModalEditorDisplayContext();
  const { path } = usePathContext();

  const handleOpenPositionsEditor = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setModalContext(path, props.value, EditorModalType.positionsEditor);
      showModal();
    },
    [setModalContext, path, props.value, showModal],
  );

  return (
    <>
      <Typography component={"span"}>{props.propName}: </Typography>
      <Button variant="outlined" onClick={(event) => handleOpenPositionsEditor(event)}>
        Edit positions
      </Button>
    </>
  );
}
